import React from 'react'
import styles from './RecruitmentPostingCompany.module.css'
import { ClientData } from './types'
import { useAbTestGtm } from '../../../../hooks/useAbTestGtm'

const CLIENT_LOGOS: ClientData[] = [
    {
        id: 'client1',
        src: '/pages/google/RecruitmentPostingCompany/clientLogo1.png',
        alt: 'Eggsn Thingsロゴ'
    },
    {
        id: 'client2',
        src: '/pages/google/RecruitmentPostingCompany/clientLogo2.png',
        alt: 'スシローロゴ'
    },
    {
        id: 'client3',
        src: '/pages/google/RecruitmentPostingCompany/clientLogo3.png',
        alt: 'TRANSITロゴ'
    },
    {
        id: 'client4',
        src: '/pages/google/RecruitmentPostingCompany/clientLogo4.png',
        alt: 'PIERRE HERMÉロゴ'
    },
    {
        id: 'client5',
        src: '/pages/google/RecruitmentPostingCompany/clientLogo5.png',
        alt: '王将ロゴ'
    },
    {
        id: 'client6',
        src: '/pages/google/RecruitmentPostingCompany/clientLogo6.png',
        alt: 'Gong chaロゴ'
    },
    {
        id: 'client7',
        src: '/pages/google/RecruitmentPostingCompany/clientLogo7.png',
        alt: 'Saizeriyaロゴ'
    },
    {
        id: 'client8',
        src: '/pages/google/RecruitmentPostingCompany/clientLogo8.png',
        alt: '焼肉キングロゴ'
    },
    {
        id: 'client9',
        src: '/pages/google/RecruitmentPostingCompany/clientLogo9.png',
        alt: 'DD GROUPロゴ'
    },
    {
        id: 'client10',
        src: '/pages/google/RecruitmentPostingCompany/clientLogo10.png',
        alt: '丸亀製麺ロゴ'
    }
]

const RecruitmentPostingCompany: React.FC = () => {
    const { dataViewLabel } = useAbTestGtm()
    return (
        <section data-view-label={dataViewLabel('CT_RecruitmentPostingCompany')}>
            <div 
                className={styles.RecruitmentPostingCompanyWrap}
                style={{
                    backgroundImage: 'url(/pages/google/RecruitmentPostingCompany/orangeGradation.png)'
                }}
            >
                <h2>
                    フーズラボが選ばれるのは、<br/>
                    <span className={styles.highlight}>飲食業界の正社員｢求人数｣</span>
                </h2>
                <h3>
          <span className={styles.number}>
            30,000<span>求人</span>
          </span>
                    以上保有
                </h3>
                <div className={styles.clientList}>
                    <p>大手企業求人も多数保有</p>
                    <div className={styles.clientLogoWrap}>
                        {CLIENT_LOGOS.map((client) => (
                            <img
                                key={client.id}
                                src={client.src}
                                alt={client.alt}
                                className={styles.clientLogo}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default RecruitmentPostingCompany
